<div class="row">
    <div class="col-md-7">
        <h2>Carriers</h2>
    </div>
</div>
<div>
    <mt-search-bar (searched)="search($event)"></mt-search-bar>
    <mt-search-filter-checkbox
        (searchCheckboxChanged)="includeSelectionChanged($event)"
        text="Include Archived"
        [value]="includeArchived"
    ></mt-search-filter-checkbox>
    <br />
    <br />
</div>

<mt-entity-list
    [entities]="carriers"
    [total]="total"
    [(currentPage)]="currentPage"
    (pageChanged)="getCarriers()"
    (itemSelectedEvent)="carrierSelected($event)"
    (columnSortedEvent)="columnSorted($event)"
    [entityListConfig]="entityListConfig"
>
</mt-entity-list>

<div *ngIf="canAdd" class="fab-wrap-b-r">
    <a class="btn btn-primary btn-fab-lg" [routerLink]="['/carriers', 'add']">
        <span class="fa fa-plus"></span>
    </a>
</div>
